<script setup lang="ts"></script>

<template>
  <div class="hidden rounded-xl border bg-white p-6 shadow-md">
    <!--  empty, for future use  -->
  </div>
</template>
